import React from 'react';
import PropTypes from 'prop-types';
import styles from './Notify.module.sass'
import CloseButton from "../Buttons/CloseButton/CloseButton";

Notify.propTypes = {
    notifyVisibility: PropTypes.bool.isRequired,
    notifyInner: PropTypes.any,
    notifyCloseHandler: PropTypes.func,
    horizontalDirection: PropTypes.oneOf(['left', 'right']),
    verticalDirection: PropTypes.oneOf(['top', 'bottom']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    customStyles: PropTypes.object
};

Notify.defaultProps = {
    horizontalDirection: 'right',
    size: 'small'
}

function Notify(props) {
    return (
        <div ref={props.reff}  style={props.customWrapperStyles} className={styles.NotifyButton}>
            {props.children}
            {props.notifyVisibility
                ?
                <div
                    style={props.customStyles}
                    className={`
                ${styles.notify} 
                ${styles[props.size]} 
                ${styles[props.horizontalDirection]}
                ${styles[props.verticalDirection]}
                `}>
                    {props.notifyCloseHandler &&
                    <CloseButton className={styles.closeButton} onClick={props.notifyCloseHandler}/>}

                    {props.notifyInner}
                </div>
                : ""}

        </div>
    );
}

export default Notify;